/* src/app/views/payment-legal-text-contract/payment-legal-text-contract-bra-bas1/payment-legal-text-contract-bra-bas1.component.scss */
.title-top {
  position: static;
  padding-top: 1.5em;
  color: #102b4e;
  text-align: left;
  font-weight: bolder;
}
.hr-style {
  border: 1px solid #102b4e;
}
.container-position {
  position: relative;
  width: 100%;
  max-width: 1060px;
  margin: 10px auto;
  padding-top: 44px;
  height: auto;
}
.dark-blue-box {
  position: absolute;
  right: 0;
  top: -8px;
  width: min(300px, 100%);
  height: auto;
  background-color: #102b4e;
  z-index: 1;
  min-height: 56px;
}
.dark-blue-box-title {
  padding: 9px 10px;
  color: #ffffff;
  text-align: center;
  font-weight: bolder;
  margin: 0;
  line-height: 1.2;
}
.light-blue-box {
  z-index: 2;
  position: relative;
  top: 0;
  left: 0;
  width: calc(100% - 32px);
  min-height: 110px;
  height: auto;
  background-color: #d9e2f3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 14px;
  padding: 10px 16px;
}
.edit-car {
  padding-left: 0.59em;
  color: #102b4e;
  font-size: 45pt;
}
.edit-cifron {
  padding-left: 0.85em;
  color: #102b4e;
  font-size: 45pt;
}
.edit-danger {
  padding-left: 0.85em;
  color: #102b4e;
  font-size: 45pt;
}
.light-blue-box-text {
  position: static;
  padding-left: 0;
  color: #102b4e;
  text-align: left;
}
.light-blue-box-text-bold {
  font-weight: bolder;
}
.light-blue-box-text-cifron {
  padding-left: 0;
}
@media only screen and (max-width: 900px) {
  .container-position {
    max-width: 100%;
    padding-top: 0;
  }
  .dark-blue-box {
    position: relative;
    right: auto;
    top: auto;
    width: 100%;
    margin-bottom: 8px;
  }
  .light-blue-box {
    width: 100%;
    min-height: 100px;
  }
  .light-blue-box-text,
  .light-blue-box-text-cifron {
    padding-left: 0;
  }
}
.custom-list-text {
  position: relative;
  list-style: none;
}
.custom-list-text .li-text {
  position: relative;
  text-align: justify;
  font-size: 10pt;
  left: -2.9em;
  color: #102b4e;
  width: 103%;
  margin: 5px;
  padding: 5px;
}
.custom-list-number .li-text:before {
  position: absolute;
}
.text-atenttion {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
}
.custom-list-alphabet {
  list-style: none;
  padding-top: 10px;
  padding-left: 2.5em;
}
.custom-list-alphabet .li-alphabet {
  position: relative;
  padding-top: 10px;
  text-align: justify;
  font-size: 10pt;
  color: #102b4e;
  counter-increment: custom-counter;
}
.custom-list-alphabet .li-alphabet:before {
  position: absolute;
  content: "(" counter(custom-counter, lower-alpha) ") ";
  margin-right: 5px;
  left: -2.5em;
}
.a-edit-blue {
  color: #0062af;
  text-decoration-line: none;
}
.a-edit-blue:hover {
  color: #008de2;
}
.custom-text-data {
  position: relative;
  padding-top: 30px;
  font-size: 10pt;
  text-align: center;
}
/*# sourceMappingURL=payment-legal-text-contract-bra-bas1.component-EFVBY3PS.css.map */
